import React from 'react';

const SvgTextInput = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.181 11.57c-.367-.921-.732-1.8-1.093-2.63s-.729-1.611-1.1-2.433H7.537c-.384.822-.754 1.605-1.11 2.433s-.718 1.705-1.085 2.626-.742 1.911-1.126 2.952S3.427 16.7 3 17.932h2.663c.121-.411.255-.8.4-1.217s.293-.838.435-1.249h4.442c.142.411.287.833.435 1.249s.282.806.4 1.217h2.745q-.64-1.849-1.216-3.411a109.57 109.57 0 0 0-1.123-2.951zm-5.088 1.841q.262-.74.518-1.414t.468-1.233l.378-.986q.164-.428.243-.678c.066.164.153.389.263.674s.238.614.386.986.3.784.469 1.233.334.921.509 1.414zM21 5.644h-1.644V18.8H21v1.643h-4.932V18.8h1.644V5.644h-1.644V4H21z" />
  </svg>
);

export default SvgTextInput;
